import styled from 'styled-components';
import Table from 'core/table';
import { InfoBanner } from 'ui/banner';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const AllCatalogsPageContent = styled.div`
  display: flex;
`;

export const SubHeaderItem = styled.dl`
  display: grid;
  grid-template-columns: max-content auto;
`;

export const SubHeaderLabel = styled.dt`
  font-weight: 600; /** conversion from a .css file */
  margin-right: ${pxToRem(10)}; /** conversion from a .css file */
  min-width: ${pxToRem(100)}; /** conversion from a .css file */
`;

export const StyledCoreTable = styled(Table)`
  &&&& {
    flex: 1 1 auto;
    max-height: calc(100vh - ${pxToRem(210)}); /** conversion from a .css file */
    min-height: ${pxToRem(80)}; /** conversion from a .css file */
    .tableCellNameLabel {
      display: flex;
      > .cellName {
        min-width: ${pxToRem(140)}; /** conversion from a .css file */
        max-width: ${pxToRem(300)}; /** conversion from a .css file */
        word-break: break-all;
      }
      &.tableCellNameLabelDelete {
        color: #717171; /** conversion from a .css file */
        > .cellName > .cellNameLabel {
          color: #717171; /** conversion from a .css file */
          text-decoration: line-through;
        }
      }
    }
  }
`;

export const StyledInfoBanner = styled(InfoBanner)`
  margin-top: ${spacing.base};
  margin-bottom: ${spacing.base};
`;

export const CTALink = styled.div`
  margin-top: ${spacing.half};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;
